import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';
import { PLATFORM_ID, APP_ID, Inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

import { ScrollToModule } from '@nicky-lenaers/ngx-scroll-to';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';


import { AppComponent } from './app.component';
import { AppRoutingModule } from './/app-routing.module';
import { HomeComponent } from './home/home.component';
import { HeaderComponent } from './header/header.component';
import { ProductsComponent } from './products/products.component';
import { ProductComponent } from './products/product/product.component';
import { ConnectComponent } from './connect/connect.component';
import { CmsService } from './cms.service';
import { ConnectService } from './connect.service';
import { PortfolioComponent } from './portfolio/portfolio.component';
import { AboutComponent } from './about/about.component';
import { FooterComponent } from './footer/footer.component';
import { CategoryComponent } from './products/category/category.component';
import { HomeResolver } from './home/home.resolver';
import { ProjectsComponent } from './portfolio/projects/projects.component';
import { CatalogComponent } from './catalog/catalog.component';
import { AuthGuard } from './auth.guard';
import { RosettaCatalogComponent } from './rosetta-catalog/rosetta-catalog.component';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    HeaderComponent,
    ProductsComponent,
    ProductComponent,
    ConnectComponent,
    PortfolioComponent,
    AboutComponent,
    FooterComponent,
    CategoryComponent,
    ProjectsComponent,
    CatalogComponent,
    RosettaCatalogComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'thinslabz' }),
    AppRoutingModule,
    FormsModule,
    HttpModule,
    HttpClientModule,
    NgbModule.forRoot(),
    ScrollToModule.forRoot()
  ],
  providers: [CmsService, ConnectService, HomeResolver, AuthGuard, ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    @Inject(APP_ID) private appId: string) {
    const platform = isPlatformBrowser(platformId) ?
      'in the browser' : 'on the server';
    console.log(`Running ${platform} with appId=${appId}`);
  }
}



// WEBPACK FOOTER //
// /tmp/build_0264da94/src/app/app.module.ts